@import '../../styles/modals.css';
@import '../../styles/buttons.css';

.tambr-modal-window.add-on-selection-window { max-width: 400px; }
.tambr-modal-body.with-padding { padding: 15px 20px 15px 17px; }

.add-ons-loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-height: 200px;
}

.add-on-section { margin-bottom: 40px; border-bottom: 1px solid #ccc; }
.add-on-section:last-child { margin-bottom: 10px; border-bottom: none; }
.add-on-section-title {
  letter-spacing: 2px;
  font-size: 12px;
  text-transform: uppercase;
  margin: 10px 0px 15px;
  padding-left: 0px;
}

.add-on-item { padding: 0 5px 5px; margin-bottom: 5px; min-height: 30px; }
.add-on-row { display: flex; align-items: center; flex-wrap: wrap; min-height: 30px; }
.add-on-item.disabled { color: #aaa; cursor: default; fill: #aaa; }
.add-on-item.disabled:hover { background: none; }

.add-on-checkbox-label { display: flex; align-items: center; min-width: 200px; max-width: 300px; }

.add-on-checkbox-col { width: 30px; cursor: pointer; }
.add-on-checkbox-col tambr-icon { width: 24px; height: 24px; display: block; }
.disabled .add-on-checkbox-col tambr-icon { opacity: 0.5; }

.add-on-info-col { padding: 5px 10px 0px 0px; flex: 7 1 0; cursor: pointer; }
.add-on-title { padding-bottom: 3px; }
.add-on-title span { font-weight: 600; padding-right: 10px; }
.disabled .add-on-title span { text-decoration: line-through; }
.add-on-description { color: #999; line-height: 1.5em; padding-left: 30px; }
.disabled .add-on-description { text-decoration: line-through; }

.add-on-quantity-price-col { display: flex; align-items: center; gap: 0.5rem; margin-left: auto; }

.add-on-quantity-col { text-align: right; flex: 1; }

.add-on-price-col { text-align: right; flex: 3; }
.add-on-price { font-weight: 600; }
.add-on-price-free { color: #999; font-style: italic; }
.add-on-price-scope { color: #999; font-size: 11px; font-style: italic; margin-top: 3px; }

.add-on-unavailable-chip {
  display: inline;
  font-size: 11px;
  color: #666;
  background: #ddd;
  text-decoration: none;
  padding: 3px 10px;
  border-radius: 15px;
}

.tambr-action-buttons { border-top: 1px solid #d5d9de; }